import React, { useState, useEffect } from "react";
import axios from "axios";

import {
  Box,
  Typography,
  // ToggleButton,
  // ToggleButtonGroup,
  // IconButton,
  Collapse
} from "@mui/material";

// import ShareTwoToneIcon from '@mui/icons-material/ShareTwoTone';
import {  ExpandLess, ExpandMore } from "@mui/icons-material";
// import DownloadTwoToneIcon from '@mui/icons-material/DownloadTwoTone';
// import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';
// import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
// import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
// import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';

// import ListIcon from "@mui/icons-material/ViewList";
// import GridViewIcon from "@mui/icons-material/GridView";
// import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ListFilesFolder from "../components/ListFilesFolder";
import TileFilesFolder from "../components/TileFilesFolder";
import Catelog from "../components/Catelog";
import Filters from "../components/Filters";
// import { useMediaQuery } from "@mui/material";
// import ListMobileView from "../components/ListMobileView";
import { useUser } from "../hooks/Authorize";
import { useTheme } from "../style/theme";
// import Sorters from "../components/Sorters";
// import { useClikkle } from "../context/ClikkleContext";
import FolderBreadcrumbs from "../components/FolderBreadcrumbs";
import AccessDenied from "../components/AccessDenied";
import useFilteredItems from "../hooks/useFilteredItems";
import { useResourceMenu } from "../context/ResourceMenuContext";
// import FilesPic from "../assets/files.png";
import NoResourcesAvailable from "../components/NoResourcesAvailable";
import { useNavigate, useLocation } from "react-router-dom";
import AddResourceMenu from "../components/SubMenus/AddResourceMenu";
import { categorizeItems, } from "../components/utils";
import FilePreviewModal from "../components/Dialogs/FilePreviewModal";
import GridListViewSelector from "../components/GridListViewSelector";
import SelectedToolbar from "../components/SelectedToolbar";
import ItemMorevertMenu from "../components/ItemMorevertMenu";



const MyFiles = ({ overrideItems, accessDenied }) => {
  const location = useLocation();
  const navigate = useNavigate(); // Used for navigation
  const queryParams = new URLSearchParams(location.search);
  const parentId = queryParams.get('parentId');

  const [selectedSort, setSelectedSort] = useState("Name");
  const [isDescending, setIsDescending] = useState(true);

  const platformUser = JSON.parse(localStorage.getItem("user"));
  var baseFilters = {}
  if (location.pathname === '/' || location.pathname === '/home') {
    baseFilters = { ownerId: platformUser._id, all: true, recent: true, includeFolders: true }
  }

  if (location.pathname === '/my-files') {
    baseFilters = { ownerId: platformUser._id }
  }
  else if (location.pathname === '/trash') {
    baseFilters = { ownerId: platformUser._id, isTrashed: true }
  }
  else if (location.pathname === '/recent') {
    baseFilters = { ownerId: platformUser._id, all: true, recent: true }
  }
  else if (location.pathname === '/favorite') {
    baseFilters = { ownerId: platformUser._id, isStarred: true }
  }
  else if (location.pathname === '/shared-by-me') {
    baseFilters = { ownerId: platformUser._id, sharedByMe: true }
  }
  else if (location.pathname === '/shared-with-me') {
    baseFilters = { ownerId: platformUser._id, sharedWithMe: true }
  }
  var isRecentView = location.pathname === '/recent';
  var isHomeView = location.pathname === '/' || location.pathname === '/home';
  var isSharedWithMe = location.pathname === '/shared-with-me' 

  const { anchorElAddResource, setAnchorElAddResource } = useResourceMenu();
  const [anchorElMoreVertMenu, setAnchorElMoreVertMenu] = useState(null);
  const [anchorElSubMenu, setAnchorElSubMenu] = useState(null);
  const [anchorElOrganizeSubMenu, setAnchorElOrganizeSubMenu] = useState(null);
  const [anchorElFolderInfoSubMenu, setAnchorElFolderInfoSubMenu] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState(null); // Tracks which submenu is open

  const [openSharingDialogModal, setOpenSharingDialogModal] = useState(false);
  const [openMoveDialogModal, setOpenMoveDialogModal] = useState(false);


  const [view, setView] = useState("list");
  const [selectedFilters, setSelectedFilters] = useState({
    type: null,
    people: null,
    modified: null,
    source: null,
  });
  // eslint-disable-next-line no-unused-vars
  const [currentFolder, setCurrentFolder] = useState(null);
  // const [RandomClikkleItems, setRandomClikkleItems] = useState([]);
  const [filePreviewModalOpen, setfilePreviewModalOpen] = useState(false);
  const [filePreviewSelectedFile, setfilePreviewSelectedFile] = useState(null);
  const {
    clikkleItems,
    setClikkleItems,
    // loading,
  } = useFilteredItems({
    baseFilters: baseFilters,
    monitorParams: [
      'parentId',
      "type",
      "people", "people_email", "people_access", "people_id",
      "location", "modified",
      "q_type", "q_ownerType", 'q_specificOwner', "q_itemName", "q_location", "q_dateModified", "q_dateFrom", "q_dateTo"
    ],
  });

  // overrideItems takes priority if passed
  const itemsToRender = overrideItems || clikkleItems;


  const [toggleFolderCatelog, setToggleFolderCatelog] = useState(true);
  const [toggleListFilesFolderTable, setToggleListFilesFolderTable] = useState(true);

  useEffect(() => {
    setClikkleItems([]); // Reset clikkleItems on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleListFilesFolderTableToggle = () => {
    setToggleListFilesFolderTable((prev) => !prev);
  };

  const handleFolderCatelogToggle = () => {
    setToggleFolderCatelog((prev) => !prev);
  };



  const [selectedToolbarItem, setSelectedToolbarItem] = useState(null);
  const [currentMenuClickedItem, setCurrentMenuClickedItem] = useState({});

  const handleRowClick = (item) => {
    console.log("handleRowClick =", item)
    setCurrentMenuClickedItem(item)  
    setSelectedToolbarItem((prev) => (prev?._id === item._id ? null : item)); 
  };
  useEffect(() => {
    const handleClickOutsideSubmenus = (event) => {
      const isInsideSubMenu =
        event.target.closest(".MuiMenu-paper") || // Main menu
        event.target.closest(".submenu-root");    // Custom class for your submenus

      if (!isInsideSubMenu) {
        // Close all open submenus safely
        setAnchorElSubMenu(null);
        setAnchorElOrganizeSubMenu(null);
        setAnchorElFolderInfoSubMenu(null);
        setSubmenuOpen(false);
      }
    };

    if (anchorElMoreVertMenu) {
      document.addEventListener("click", handleClickOutsideSubmenus);
    }

    return () => {
      document.removeEventListener("click", handleClickOutsideSubmenus);
    };
  }, [anchorElMoreVertMenu]);


  useEffect(() => {
    const handleClickOutsideSelection = (event) => {
      const toolbarEl = document.getElementById("selected-toolbar");
      const tableEl = document.querySelector(".MuiTable-root"); // or use a ref as mentioned earlier

      const isInsideMenu =
        event.target.closest(".MuiMenu-paper") || event.target.closest(".submenu-root");

      // If the click is outside toolbar, table, and menus — clear selection
      if (
        !toolbarEl?.contains(event.target) &&
        !tableEl?.contains(event.target) &&
        !isInsideMenu
      ) {
        setSelectedToolbarItem(null);
      }
    };

    // Only listen if something is selected
    if (selectedToolbarItem) {
      document.addEventListener("click", handleClickOutsideSelection);
    }

    return () => {
      document.removeEventListener("click", handleClickOutsideSelection);
    };
  }, [selectedToolbarItem]);


  const handleMoreVertMenuOpen = (event, item) => {
    setAnchorElMoreVertMenu(event.currentTarget);
    setCurrentMenuClickedItem(item);
    console.log("Menu opened: ", item)
  };


  // eslint-disable-next-line no-unused-vars
  const [selectedRows, setSelectedRows] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const { mode } = useTheme();

  const handleViewChange = (event, newView) => {
    if (newView !== null) setView(newView);
  };


  const handleFolderNavigationClick = async (item) => {
    console.log("current page = ", location.pathname);

    if (item.type === "folder") {
      let parentId = item._id;
      if (item.isShortcut) {
        parentId = item.shortcutTarget;
      }


      // Default to current path and query
      let newPath = location.pathname;
      const queryParams = new URLSearchParams(window.location.search);

      // Update parentId
      queryParams.set("parentId", parentId);

      // If on home or root, determine which path to switch to
      if (location.pathname === "/" || location.pathname === "/home") {
        if (item.ownerId === platformUser._id) {
          newPath = "/my-files";
        } else {
          newPath = "/shared-with-me";
          queryParams.set("sharedWithMe", "true");
        }
      } else if (location.pathname.includes("/shared-with-me")) {
        queryParams.set("sharedWithMe", "true");
      }

      console.log("path = ", `${newPath}?${queryParams.toString()}`)
      navigate(`${newPath}?${queryParams.toString()}`, { replace: true });

    } else if (item.type === "file") {
      setfilePreviewSelectedFile(item);
      setfilePreviewModalOpen(true);
      await addResourceActivity(item, 'VIEWED');
    }

    setSelectedToolbarItem(null)
  };

  const handleDoubleClickFilePreview = async (item) => {
    if (item.type === "file") {
      setfilePreviewSelectedFile(item);
      setfilePreviewModalOpen(true);
      await addResourceActivity(item, 'VIEWED')
    }
  }


  const addResourceActivity = async (item, activityName) => {
    await axios.post(
      `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/activity`,
      {
        resourceId: item._id,
        name: activityName,
        userId: platformUser._id,
      },
    );
  }

  // const isMobile = useMediaQuery("(max-width:600px)");

  const tableHeadings = {
    name: true,
    owner: true,
    location: false,
    size: true,
    reason: false,
    last_modified: true,
    sharing_date: isSharedWithMe,
  };

  // if (isMobile) {
  //   return (
  //     <Box
  //       sx={{
  //         padding: "0.5rem",
  //         height: "calc(100% - 1rem)",
  //         overflow: "scroll",
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           display: "flex",
  //           justifyContent: "space-between",
  //           alignItems: "center",
  //         }}
  //       >
  //         <Typography
  //           sx={{
  //             fontSize: "1rem",
  //           }}
  //         >
  //           Files
  //         </Typography>
  //         <Box>
  //           {view === "folder" ? (
  //             <IconButton onClick={() => handleViewChange(null, "list")}>
  //               <GridViewIcon />
  //             </IconButton>
  //           ) : (
  //             <IconButton onClick={() => handleViewChange(null, "folder")}>
  //               <ListIcon />
  //             </IconButton>
  //           )}
  //         </Box>
  //       </Box>
  //       <Box padding={"0.5rem"}>

  //         {view === "list" ? (

  //           <ListMobileView
  //             items={[...itemsToRender, ...RandomClikkleItems, ...RandomClikkleItems]}
  //           />
  //         ) : (
  //             <TileFilesFolder 
  //             items={[...itemsToRender, ...RandomClikkleItems, ...RandomClikkleItems]}
  //           />
  //         )}

  //       </Box>
  //     </Box>
  //   )
  // }
  if (accessDenied) {

    return (
      <>
        <AddResourceMenu
          setClikkleItems={setClikkleItems}
          clikkleItems={clikkleItems}
          anchorEl={anchorElAddResource}
          onClose={() => (setAnchorElAddResource(null))}
        />
        <AccessDenied
        //  resourceName={item?.name || "This item"} 
        //  resourceType={item?.type} 
        />
      </>)
  }
  return (
    <>

      {filePreviewSelectedFile && filePreviewModalOpen &&
        <FilePreviewModal
          open={filePreviewModalOpen}
          // handleClose={handleCloseModal}
          setfilePreviewSelectedFile={setfilePreviewSelectedFile}
          setfilePreviewModalOpen={setfilePreviewModalOpen}
          file={filePreviewSelectedFile}
          userId={platformUser._id} // Pass the user ID here
        />}

      <AddResourceMenu
        setClikkleItems={setClikkleItems}
        clikkleItems={clikkleItems}
        anchorEl={anchorElAddResource}
        onClose={() => (setAnchorElAddResource(null))}
      />

      <ItemMorevertMenu
        anchorEl={anchorElMoreVertMenu}
        openSharingDialogModal={openSharingDialogModal}
        setOpenSharingDialogModal={setOpenSharingDialogModal}
        openMoveDialogModal={openMoveDialogModal}
        setOpenMoveDialogModal={setOpenMoveDialogModal}
        anchorElSubMenu={anchorElSubMenu}
        setAnchorElSubMenu={setAnchorElSubMenu}
        anchorElOrganizeSubMenu={anchorElOrganizeSubMenu}
        setAnchorElOrganizeSubMenu={setAnchorElOrganizeSubMenu}
        anchorElFolderInfoSubMenu={anchorElFolderInfoSubMenu}
        setAnchorElFolderInfoSubMenu={setAnchorElFolderInfoSubMenu}
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        setAnchorEl={setAnchorElMoreVertMenu}
        currentMenuClickedItem={currentMenuClickedItem}
        item={currentMenuClickedItem}
        setClikkleItems={setClikkleItems}
        items={itemsToRender}
        handleDoubleClickFilePreview={handleDoubleClickFilePreview}
      />


      <Box p={"1rem"}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          width="100%"
          gap={isRecentView ? "1rem" : '1rem'}
          sx={{
            height: "calc(100vh - 8rem)",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              display: "none", // For Chrome, Safari, and Edge
            },
          }}
        >
          <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
            {selectedRows.length === 0 &&
              <>
                {!selectedToolbarItem && <Filters
                  leftImg={false} selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                  setClikkleItems={setClikkleItems} />
                }

                {selectedToolbarItem && (
                  <SelectedToolbar
                    onClearSelection={() => setSelectedToolbarItem(null)}
                    handleMoreVertMenuOpen={handleMoreVertMenuOpen}
                    item={selectedToolbarItem}
                    setOpenSharingDialogModal={setOpenSharingDialogModal}
                    setClikkleItems={setClikkleItems}
                    setOpenMoveDialogModal={setOpenMoveDialogModal}
                  />
                )}

              </>
            }

            {!isHomeView &&
              <GridListViewSelector view={view} handleViewChange={handleViewChange} />
            }


          </Box>
          {/* {selectedRows.length > 0 && (
            <Box sx={{
              // position: "absolute",

              display: "flex",
              alignItems: "center",
              gap: 1,
              border: "2px solid rgba(31,31,31)",
              borderRadius: "35px",
              padding: "5px",
              backgroundColor: mode === "light" ? "#fff" : "rgb(31,31,31)",
            }}>
              <IconButton onClick={() => setSelectedRows([])}>
                <Close fontSize="small" />
              </IconButton>
              <Typography sx={{ paddingRight: '35px' }}>{selectedRows.length} Selected</Typography>
              <IconButton>
                <ShareTwoToneIcon fontSize="small" />
              </IconButton>
              <IconButton>
                <DownloadTwoToneIcon fontSize="small" />
              </IconButton>
              <IconButton>
                <DriveFileMoveOutlinedIcon fontSize="small" />
              </IconButton>
              <IconButton>
                <DeleteOutlinedIcon fontSize="small" />
              </IconButton>
              <IconButton>
                <LinkOutlinedIcon fontSize="small" sx={{ transform: 'rotate(135deg)' }} />
              </IconButton>
              <IconButton>
                <MoreVertOutlinedIcon fontSize="small" />
              </IconButton>

            </Box>
          )} */}

          <FolderBreadcrumbs setClikkleItems={setClikkleItems} />


          {isHomeView && !parentId &&
            <Box>
              {isHomeView && itemsToRender.length > 0 && (
                <Box
                  sx={{
                    p: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%', // or 'fit-content' if needed
                    paddingBottom: 1
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    {/* Toggle Section */}
                    <Box
                      onClick={handleFolderCatelogToggle}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: '#4A90E2',
                      }}
                    >
                      {toggleFolderCatelog ? (
                        <ExpandLess sx={{ fontSize: 30 }} />
                      ) : (
                        <ExpandMore sx={{ fontSize: 30 }} />
                      )}
                      <Typography sx={{ ml: 0.5, fontSize: 17 }} variant="body2">
                        Suggested Folders
                      </Typography>
                    </Box>


                  </Box>

                </Box>


              )}
              <Collapse in={toggleFolderCatelog} timeout="auto" unmountOnExit>
                <Catelog
                  handleRowClick={handleRowClick}
                  handleMoreVertMenuOpen={handleMoreVertMenuOpen}
                  items={itemsToRender.filter((item) => { return item.type === "folder"; }).slice(0, 10)}
                  setClikkleItems={setClikkleItems}
                  isRecentView={isRecentView}
                  title={""}
                  showTitle={false}
                  selectedSort={selectedSort}
                  setSelectedSort={setSelectedSort}
                  isDescending={isDescending}
                  showLocation={true}
                  setIsDescending={setIsDescending}
                  handleFolderNavigationClick={handleFolderNavigationClick}
                />
              </Collapse>

              {isHomeView && itemsToRender.length > 0 && (
                <Box
                  sx={{
                    p: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%', // or 'fit-content' if needed
                    paddingBottom: 1
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    {/* Toggle Section */}
                    <Box
                      onClick={handleListFilesFolderTableToggle}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: '#4A90E2',
                      }}
                    >
                      {toggleListFilesFolderTable ? (
                        <ExpandLess sx={{ fontSize: 30 }} />
                      ) : (
                        <ExpandMore sx={{ fontSize: 30 }} />
                      )}
                      <Typography sx={{ ml: 0.5, fontSize: 17 }} variant="body2">
                        Suggested Files
                      </Typography>
                    </Box>

                    <GridListViewSelector view={view} handleViewChange={handleViewChange} />

                  </Box>

                  {toggleListFilesFolderTable &&
                    <Collapse in={toggleListFilesFolderTable} timeout="auto" unmountOnExit>
                      <>

                        {view === "folder" && <TileFilesFolder
                          handleMoreVertMenuOpen={handleMoreVertMenuOpen}
                          items={itemsToRender.filter((item) => { return item.type === "file"; })}
                          setClikkleItems={setClikkleItems}
                          handleRowClick={handleRowClick}
                          isRecentView={isRecentView}
                          title={""}
                          selectedSort={selectedSort}
                          setSelectedSort={setSelectedSort}
                          isDescending={isDescending}
                          setIsDescending={setIsDescending}
                          handleDoubleClickFilePreview={handleDoubleClickFilePreview}

                        />}
                        {view === 'list' &&
                          <ListFilesFolder
                            menuAnchorEl={anchorElMoreVertMenu}
                            setMenuAnchorEl={setAnchorElMoreVertMenu}
                            handleMoreVertMenuOpen={handleMoreVertMenuOpen}
                            items={itemsToRender}
                            handleRowClick={handleRowClick}
                            tableHeadings={tableHeadings}
                            setClikkleItems={setClikkleItems}
                            selectedFilters={selectedFilters}
                            setCurrentFolder={setCurrentFolder}
                            handleFolderNavigationClick={handleFolderNavigationClick}
                            handleDoubleClickFilePreview={handleDoubleClickFilePreview}
                          />
                        }

                      </>
                    </Collapse>
                  }
                </Box>
              )}

            </Box>

          }

          {view === "folder" && (
            itemsToRender.length === 0 ? (
              <>
                {/* Show this when no items are present */}
                <NoResourcesAvailable />

              </>
            ) : (
              <>
                <Box
                  display="flex"
                  flexDirection="column"
                  gap="1rem"
                  sx={{
                    width: "100%", // Set the width
                    paddingTop: "0rem",
                    marginTop: "0rem",
                    maxHeight: "calc(100vh - 8rem)",
                    overflowY: "auto",
                    // Enable vertical scrolling
                    "&::-webkit-scrollbar": {
                      display: "none", // For Chrome, Safari, and Edge
                    }, // Enable vertical scrolling
                  }}
                >


                  <Box>

                    {!isHomeView && !isRecentView &&

                      <Catelog
                        handleMoreVertMenuOpen={handleMoreVertMenuOpen}
                        handleRowClick={handleRowClick}
                        items={itemsToRender.filter((item) => { return item.type === "folder"; })}
                        setClikkleItems={setClikkleItems}
                        isRecentView={isRecentView}
                        title={"Folders"}
                        selectedSort={selectedSort}
                        setSelectedSort={setSelectedSort}
                        isDescending={isDescending}
                        setIsDescending={setIsDescending}
                        handleFolderNavigationClick={handleFolderNavigationClick}
                      />}
                  </Box>
                  <Box>

                    {!isHomeView && !isRecentView &&
                      <TileFilesFolder
                        handleMoreVertMenuOpen={handleMoreVertMenuOpen}
                        items={itemsToRender.filter((item) => { return item.type === "file"; })}
                        setClikkleItems={setClikkleItems}
                        isRecentView={isRecentView}
                        title={"Files"}
                        selectedSort={selectedSort}
                        setSelectedSort={setSelectedSort}
                        isDescending={isDescending}
                        setIsDescending={setIsDescending}
                        handleDoubleClickFilePreview={handleDoubleClickFilePreview}

                      />
                    }
                    {isRecentView && <>
                      {Object.entries(categorizeItems(clikkleItems)).map(([category, items], index) => {
                        console.log('category = ', category)
                        if (items.length > 0) {

                          return <Box key={category}
                            sx={{
                              marginTop: 0
                            }}
                          >
                            <Typography
                              sx={{
                                color: "rgba(165, 165, 165, 1)",
                                fontSize: "18px",
                                fontWeight: 500,
                                marginTop: 3.5,
                                marginBottom: 2,
                              }}
                            >{category}</Typography>

                            <TileFilesFolder
                              handleMoreVertMenuOpen={handleMoreVertMenuOpen}
                              items={items.filter((item) => { return item.type === "file"; })}
                              setClikkleItems={setClikkleItems}
                              isRecentView={isRecentView}
                              title={"Files"}
                              selectedSort={selectedSort}
                              setSelectedSort={setSelectedSort}
                              isDescending={isDescending}
                              setIsDescending={setIsDescending}
                            />
                          </Box>
                        }
                        else {
                          return <></>
                        }
                      }
                      )}
                    </>
                    }

                  </Box>
                </Box>
              </>
            )
          )}

          {view === "list" && (
            <Box
              display={"flex"}
              width={"100%"}
              sx={{
                maxHeight: "calc(100vh - 8rem)",
                overflowY: "auto",
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                // gap="1rem"
                sx={{
                  width: "100%", // Set the width
                  maxHeight: "82vh", // Set the maximum height
                  overflowY: "auto",
                  // paddingTop: "1rem",
                  // Enable vertical scrolling
                  "&::-webkit-scrollbar": {
                    display: "none", // For Chrome, Safari, and Edge
                  }, // Enable vertical scrolling
                }}
              >
                {!isHomeView && !isRecentView && itemsToRender.length > 0 && toggleListFilesFolderTable &&
                  <Collapse in={toggleListFilesFolderTable} timeout="auto" unmountOnExit>
                    <ListFilesFolder
                      menuAnchorEl={anchorElMoreVertMenu}
                      setMenuAnchorEl={setAnchorElMoreVertMenu}
                      handleMoreVertMenuOpen={handleMoreVertMenuOpen}
                      items={itemsToRender}
                      handleRowClick={handleRowClick}
                      tableHeadings={tableHeadings}
                      setClikkleItems={setClikkleItems}
                      selectedFilters={selectedFilters}
                      setCurrentFolder={setCurrentFolder}
                      handleFolderNavigationClick={handleFolderNavigationClick}
                      handleDoubleClickFilePreview={handleDoubleClickFilePreview}
                    />
                  </Collapse>
                }
                {isRecentView && <>

                  <div style={{ paddingTop: 3 }}>
                    <ListFilesFolder
                      items={[]}
                      tableHeadings={tableHeadings}
                      showTableHeader={1}
                      selectedFilters={selectedFilters}
                      handleRowClick={handleRowClick}
                      handleDoubleClickFilePreview={handleDoubleClickFilePreview}
                      handleFolderNavigationClick={handleFolderNavigationClick}

                    />
                  </div>
                  {Object.entries(categorizeItems(clikkleItems)).map(([category, items], index) =>
                    items.length > 0 ? (
                      <div key={category}>
                        <Typography
                          sx={{
                            color: "rgba(165, 165, 165, 1)",
                            fontSize: "18px",
                            fontWeight: 300,
                            marginTop: index === 0 ? 1 : 3.5,
                            paddingLeft: 3
                            // marginBottom:2,
                          }}
                        >{category}</Typography>

                        <ListFilesFolder
                          menuAnchorEl={anchorElMoreVertMenu}
                          setMenuAnchorEl={setAnchorElMoreVertMenu}
                          handleMoreVertMenuOpen={handleMoreVertMenuOpen}
                          items={itemsToRender}
                          handleRowClick={handleRowClick}
                          tableHeadings={tableHeadings}
                          showTableHeader={false}
                          selectedFilters={selectedFilters}
                          handleDoubleClickFilePreview={handleDoubleClickFilePreview}
                          handleFolderNavigationClick={handleFolderNavigationClick}

                        />
                      </div>
                    ) : null
                  )}
                </>
                }

                {itemsToRender.length === 0 &&
                  <>
                    <NoResourcesAvailable />
                  </>
                }

              </Box>
            </Box>
          )}


        </Box>
      </Box>
    </>
  );
};

export default MyFiles;
